/*
 * @Description: 组件描述
 * @Author: huangzhenpeng
 * @Date: 2020-07-06 14:21:49
 * @LastEditors: huangzhenpeng
 * @LastEditTime: 2020-07-07 09:06:08
 */
var SM3 = (function () {
  var CryptoJS = CryptoJS || (function (J, A) {
    var E = {}
    var K = E.lib = {}
    var N = K.Base = (function () {
      function C () {}
      return {
        extend: function (P) {
          C.prototype = this
          var O = new C()
          if (P) {
            O.mixIn(P)
          }
          if (!O.hasOwnProperty('init')) {
            O.init = function () {
              O.$super.init.apply(this, arguments)
            }
          }
          O.init.prototype = O
          O.$super = this
          return O
        },
        create: function () {
          var O = this.extend()
          O.init.apply(O, arguments)
          return O
        },
        init: function () {},
        mixIn: function (P) {
          for (var O in P) {
            if (P.hasOwnProperty(O)) {
              this[O] = P[O]
            }
          }
          if (P.hasOwnProperty('toString')) {
            this.toString = P.toString
          }
        },
        clone: function () {
          return this.init.prototype.extend(this)
        }
      }
    }())
    var B = K.WordArray = N.extend({
      init: function (C, O) {
        C = this.words = C || []
        if (O != A) {
          this.sigBytes = O
        } else {
          this.sigBytes = C.length * 4
        }
      },
      toString: function (C) {
        return (C || D).stringify(this)
      },
      concat: function (R) {
        var P = this.words
        var T = R.words
        var C = this.sigBytes
        var S = R.sigBytes
        this.clamp()
        if (C % 4) {
          for (var O = 0; O < S; O += 1) {
            var Q = (T[O >>> 2] >>> (24 - (O % 4) * 8)) & 255
            P[(C + O) >>> 2] |= Q << (24 - ((C + O) % 4) * 8)
          }
        } else {
          if (T.length > 65535) {
            for (var O = 0; O < S; O += 4) {
              P[(C + O) >>> 2] = T[O >>> 2]
            }
          } else {
            P.push.apply(P, T)
          }
        }
        this.sigBytes += S
        return this
      },
      clamp: function () {
        var C = this.words
        var O = this.sigBytes
        C[O >>> 2] &= 4294967295 << (32 - (O % 4) * 8)
        C.length = J.ceil(O / 4)
      },
      clone: function () {
        var C = N.clone.call(this)
        C.words = this.words.slice(0)
        return C
      },
      random: function (P) {
        var C = []
        for (var O = 0; O < P; O += 4) {
          C.push((J.random() * 4294967296) | 0)
        }
        return new B.init(C, P)
      }
    })
    var I = E.enc = {}
    var D = I.Hex = {
      stringify: function (P) {
        var C = P.words
        var S = P.sigBytes
        var Q = []
        for (var O = 0; O < S; O += 1) {
          var R = (C[O >>> 2] >>> (24 - (O % 4) * 8)) & 255
          Q.push((R >>> 4).toString(16))
          Q.push((R & 15).toString(16))
        }
        return Q.join('')
      },
      parse: function (P) {
        var Q = P.length
        var C = []
        for (var O = 0; O < Q; O += 2) {
          C[O >>> 3] |= parseInt(P.substr(O, 2), 16) << (24 - (O % 8) * 4)
        }
        return new B.init(C, Q / 2)
      }
    }
    var M = I.Latin1 = {
      stringify: function (P) {
        var C = P.words
        var S = P.sigBytes
        var Q = []
        for (var O = 0; O < S; O += 1) {
          var R = (C[O >>> 2] >>> (24 - (O % 4) * 8)) & 255
          Q.push(String.fromCharCode(R))
        }
        return Q.join('')
      },
      parse: function (O) {
        var Q = O.length
        var C = []
        for (var P = 0; P < Q; P += 1) {
          C[P >>> 2] |= (O.charCodeAt(P) & 255) << (24 - (P % 4) * 8)
        }
        return new B.init(C, Q)
      }
    }
    var G = I.Utf8 = {
      stringify: function (O) {
        try {
          return decodeURIComponent(escape(M.stringify(O)))
        } catch (C) {
          throw new Error('Malformed UTF-8 data')
        }
      },
      parse: function (C) {
        return M.parse(unescape(encodeURIComponent(C)))
      }
    }
    var L = K.BufferedBlockAlgorithm = N.extend({
      reset: function () {
        this._data = new B.init()
        this._nDataBytes = 0
      },
      _append: function (C) {
        if (typeof C === 'string') {
          C = G.parse(C)
        }
        this._data.concat(C)
        this._nDataBytes += C.sigBytes
      },
      _process: function (O) {
        var Q = this._data
        var C = Q.words
        var S = Q.sigBytes
        var R = this.blockSize
        var V = R * 4
        var W = S / V
        if (O) {
          W = J.ceil(W)
        } else {
          W = J.max((W | 0) - this._minBufferSize, 0)
        }
        var U = W * R
        var T = J.min(U * 4, S)
        if (U) {
          for (var P = 0; P < U; P += R) {
            this._doProcessBlock(C, P)
          }
          var X = C.splice(0, U)
          Q.sigBytes -= T
        }
        return new B.init(X, T)
      },
      clone: function () {
        var C = N.clone.call(this)
        C._data = this._data.clone()
        return C
      },
      _minBufferSize: 0
    })
    var F = K.Hasher = L.extend({
      cfg: N.extend(),
      init: function (C) {
        this.cfg = this.cfg.extend(C)
        this.reset()
      },
      reset: function () {
        L.reset.call(this)
        this._doReset()
      },
      update: function (C) {
        this._append(C)
        this._process()
        return this
      },
      finalize: function (C) {
        if (C) {
          this._append(C)
        }
        var O = this._doFinalize()
        return O
      },
      blockSize: 512 / 32,
      _createHelper: function (C) {
        return function (P, O) {
          return new C.init(O).finalize(P)
        }
      },
      _createHmacHelper: function (C) {
        return function (P, O) {
          return new H.HMAC.init(C, O).finalize(P)
        }
      }
    })
    var H = E.algo = {}
    return E
  }(Math))

  var dbits
  var canary = 244837814094590
  var j_lm = ((canary & 16777215) == 15715070)
  var BI_FP = 52

  function BigInteger (C, A, B) {
    if (C != null) {
      if (typeof C === 'number') {
        this.fromNumber(C, A, B)
      } else {
        if (A == null && typeof C !== 'string') {
          this.fromString(C, 256)
        } else {
          this.fromString(C, A)
        }
      }
    }
  }

  function am1 (B, E, F, G, A, C) {
    while (--C >= 0) {
      var D = E * this[B++] + F[G] + A
      A = Math.floor(D / 67108864)
      F[G++] = D & 67108863
    }
    return A
  }
  function am2 (E, J, B, C, K, F) {
    var A = J & 32767
    var D = J >> 15
    while (--F >= 0) {
      var H = this[E] & 32767
      var G = this[E++] >> 15
      var I = D * H + G * A
      H = A * H + ((I & 32767) << 15) + B[C] + (K & 1073741823)
      K = (H >>> 30) + (I >>> 15) + D * G + (K >>> 30)
      B[C++] = H & 1073741823
    }
    return K
  }
  function am3 (E, J, B, C, K, F) {
    var A = J & 16383
    var D = J >> 14
    while (--F >= 0) {
      var H = this[E] & 16383
      var G = this[E++] >> 14
      var I = D * H + G * A
      H = A * H + ((I & 16383) << 14) + B[C] + K
      K = (H >> 28) + (I >> 14) + D * G
      B[C++] = H & 268435455
    }
    return K
  }
  if (j_lm && (navigator.appName == 'Microsoft Internet Explorer')) {
    BigInteger.prototype.am = am2
    dbits = 30
  } else {
    if (j_lm && (navigator.appName != 'Netscape')) {
      BigInteger.prototype.am = am1
      dbits = 26
    } else {
      BigInteger.prototype.am = am3
      dbits = 28
    }
  }
  function nbi () {
    return new BigInteger(null)
  }
  BigInteger.prototype.DB = dbits
  BigInteger.prototype.DM = ((1 << dbits) - 1)
  BigInteger.prototype.DV = (1 << dbits)
  BigInteger.prototype.FV = Math.pow(2, BI_FP)
  BigInteger.prototype.F1 = BI_FP - dbits
  BigInteger.prototype.F2 = 2 * dbits - BI_FP
  BigInteger.prototype.fromInt = bnpFromInt
  BigInteger.prototype.signum = bnSigNum
  BigInteger.prototype.shiftRight = bnShiftRight
  BigInteger.prototype.lShiftTo = bnpLShiftTo
  BigInteger.prototype.rShiftTo = bnpRShiftTo
  BigInteger.prototype.intValue = bnIntValue

  function bnIntValue () {
    if (this.s < 0) {
      if (this.t == 1) {
        return this[0] - this.DV
      } else {
        if (this.t == 0) {
          return -1
        }
      }
    } else {
      if (this.t == 1) {
        return this[0]
      } else {
        if (this.t == 0) {
          return 0
        }
      }
    }
    return ((this[1] & ((1 << (32 - this.DB)) - 1)) << this.DB) | this[0]
  }
  function bnpLShiftTo (G, A) {
    var B = G % this.DB
    var E = this.DB - B
    var C = (1 << E) - 1
    var D = Math.floor(G / this.DB)
    var H = (this.s << B) & this.DM
    var F
    for (F = this.t - 1; F >= 0; F -= 1) {
      A[F + D + 1] = (this[F] >> E) | H
      H = (this[F] & C) << B
    }
    for (F = D - 1; F >= 0; F -= 1) {
      A[F] = 0
    }
    A[D] = H
    A.t = this.t + D + 1
    A.s = this.s
    A.clamp()
  }
  function bnpRShiftTo (C, B) {
    B.s = this.s
    var A = Math.floor(C / this.DB)
    if (A >= this.t) {
      B.t = 0
      return
    }
    var E = C % this.DB
    var G = this.DB - E
    var F = (1 << E) - 1
    B[0] = this[A] >> E
    for (var D = A + 1; D < this.t; D += 1) {
      B[D - A - 1] |= (this[D] & F) << G
      B[D - A] = this[D] >> E
    }
    if (E > 0) {
      B[this.t - A - 1] |= (this.s & F) << G
    }
    B.t = this.t - A
    B.clamp()
  }
  function bnShiftRight (B) {
    var A = nbi()
    if (B < 0) {
      this.lShiftTo(-B, A)
    } else {
      this.rShiftTo(B, A)
    }
    return A
  }
  function bnSigNum () {
    if (this.s < 0) {
      return -1
    } else {
      if (this.t <= 0 || (this.t == 1 && this[0] <= 0)) {
        return 0
      } else {
        return 1
      }
    }
  }
  function bnpFromInt (A) {
    this.t = 1
    this.s = (A < 0) ? -1 : 0
    if (A > 0) {
      this[0] = A
    } else {
      if (A < -1) {
        this[0] = A + this.DV
      } else {
        this.t = 0
      }
    }
  }

  function SM3Digest () {
    this.BYTE_LENGTH = 64
    this.xBuf = []
    this.xBufOff = 0
    this.byteCount = 0
    this.DIGEST_LENGTH = 32
    this.v0 = [1937774191, 1226093241, 388252375, -628488704, -1452330820, 372324522, -477237683, -1325724082]
    this.v = [0, 0, 0, 0, 0, 0, 0, 0]
    this.v_ = [0, 0, 0, 0, 0, 0, 0, 0]
    this.X0 = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
    this.X = [68]
    this.xOff = 0
    this.T_00_15 = 2043430169
    this.T_16_63 = 2055708042
    if (arguments.length > 0) {
      this.InitDigest(arguments[0])
    } else {
      this.Init()
    }
  }
  SM3Digest.prototype = {
    Init: function () {
      this.xBuf = [0, 0, 0, 0]
      this.Reset()
    },
    InitDigest: function (A) {
      this.xBuf = [A.xBuf.length]
      Array.Copy(A.xBuf, 0, this.xBuf, 0, A.xBuf.length)
      this.xBufOff = A.xBufOff
      this.byteCount = A.byteCount
      Array.Copy(A.X, 0, this.X, 0, A.X.length)
      this.xOff = A.xOff
      Array.Copy(A.v, 0, this.v, 0, A.v.length)
    },
    GetDigestSize: function () {
      return this.DIGEST_LENGTH
    },
    Reset: function () {
      this.byteCount = 0
      this.xBufOff = 0
      Array.Clear(this.xBuf, 0, this.xBuf.length)
      Array.Copy(this.v0, 0, this.v, 0, this.v0.length)
      this.xOff = 0
      Array.Copy(this.X0, 0, this.X, 0, this.X0.length)
    },
    GetByteLength: function () {
      return this.BYTE_LENGTH
    },
    ProcessBlock: function () {
      var H
      var E = this.X
      var A = [64]
      for (H = 16; H < 68; H += 1) {
        E[H] = this.P1(E[H - 16] ^ E[H - 9] ^ (roateLeft(E[H - 3], 15))) ^ (roateLeft(E[H - 13], 7)) ^ E[H - 6]
      }
      for (H = 0; H < 64; H += 1) {
        A[H] = E[H] ^ E[H + 4]
      }
      var F = this.v
      var J = this.v_
      Array.Copy(F, 0, J, 0, this.v0.length)
      var B, C, G, I, D
      for (H = 0; H < 16; H += 1) {
        D = roateLeft(J[0], 12)
        B = D + J[4] + roateLeft(this.T_00_15, H)
        B = roateLeft(B, 7)
        C = B ^ D
        G = this.FF_00_15(J[0], J[1], J[2]) + J[3] + C + A[H]
        I = this.GG_00_15(J[4], J[5], J[6]) + J[7] + B + E[H]
        J[3] = J[2]
        J[2] = roateLeft(J[1], 9)
        J[1] = J[0]
        J[0] = G
        J[7] = J[6]
        J[6] = roateLeft(J[5], 19)
        J[5] = J[4]
        J[4] = this.P0(I)
      }
      for (H = 16; H < 64; H += 1) {
        D = roateLeft(J[0], 12)
        B = D + J[4] + roateLeft(this.T_16_63, H)
        B = roateLeft(B, 7)
        C = B ^ D
        G = this.FF_16_63(J[0], J[1], J[2]) + J[3] + C + A[H]
        I = this.GG_16_63(J[4], J[5], J[6]) + J[7] + B + E[H]
        J[3] = J[2]
        J[2] = roateLeft(J[1], 9)
        J[1] = J[0]
        J[0] = G
        J[7] = J[6]
        J[6] = roateLeft(J[5], 19)
        J[5] = J[4]
        J[4] = this.P0(I)
      }
      for (H = 0; H < 8; H += 1) {
        F[H] ^= (J[H])
      }
      this.xOff = 0
      Array.Copy(this.X0, 0, this.X, 0, this.X0.length)
    },
    ProcessWord: function (B, A) {
      var C = B[A] << 24
      C |= (B[A += 1] & 255) << 16
      C |= (B[A += 1] & 255) << 8
      C |= (B[A += 1] & 255)
      this.X[this.xOff] = C
      if (++this.xOff == 16) {
        this.ProcessBlock()
      }
    },
    ProcessLength: function (A) {
      if (this.xOff > 14) {
        this.ProcessBlock()
      }
      this.X[14] = (this.URShiftLong(A, 32))
      this.X[15] = (A & (4294967295))
    },
    IntToBigEndian: function (B, C, A) {
      C[A] = (B >>> 24 & 255)
      C[A += 1] = (B >>> 16 & 255)
      C[A += 1] = (B >>> 8 & 255)
      C[A += 1] = (B & 255)
    },
    DoFinal: function (C, A) {
      this.Finish()
      for (var B = 0; B < 8; B += 1) {
        this.IntToBigEndian(this.v[B], C, A + B * 4)
      }
      this.Reset()
      return this.DIGEST_LENGTH
    },
    Update: function (A) {
      this.xBuf[this.xBufOff++] = A
      if (this.xBufOff == this.xBuf.length) {
        this.ProcessWord(this.xBuf, 0)
        this.xBufOff = 0
      }
      this.byteCount++
    },
    BlockUpdate: function (C, A, B) {
      while ((this.xBufOff != 0) && (B > 0)) {
        this.Update(C[A])
        A += 1
        B -= 1
      }
      while (B > this.xBuf.length) {
        this.ProcessWord(C, A)
        A += this.xBuf.length
        B -= this.xBuf.length
        this.byteCount += this.xBuf.length
      }
      while (B > 0) {
        this.Update(C[A])
        A += 1
        B -= 1
      }
    },
    Finish: function () {
      var A = (this.byteCount << 3)
      this.Update((128))
      while (this.xBufOff != 0) {
        this.Update((0))
      }
      this.ProcessLength(A)
      this.ProcessBlock()
    },
    ROTATE: function (B, A) {
      return (B << A) | (this.URShift(B, (32 - A)))
    },
    P0: function (A) {
      return ((A) ^ roateLeft((A), 9) ^ roateLeft((A), 17))
    },
    P1: function (A) {
      return ((A) ^ roateLeft((A), 15) ^ roateLeft((A), 23))
    },
    FF_00_15: function (B, C, A) {
      return (B ^ C ^ A)
    },
    FF_16_63: function (B, C, A) {
      return ((B & C) | (B & A) | (C & A))
    },
    GG_00_15: function (B, C, A) {
      return (B ^ C ^ A)
    },
    GG_16_63: function (B, C, A) {
      return ((B & C) | (~B & A))
    },
    URShift: function (B, A) {
      console.error(B)
      if (B > Int32.maxValue || B < Int32.minValue) {
        console.error(B)
        B = IntegerParse(B)
      }
      if (B >= 0) {
        return B >> A
      } else {
        return (B >> A) + (2 << ~A)
      }
    },
    URShiftLong: function (A, C) {
      var J
      var B = new BigInteger()
      B.fromInt(A)
      if (B.signum() >= 0) {
        J = B.shiftRight(C).intValue()
      } else {
        var E = new BigInteger()
        E.fromInt(2)
        var K = ~C
        var F = ''
        if (K < 0) {
          var I = 64 + K
          for (var H = 0; H < I; H += 1) {
            F += '0'
          }
          var G = new BigInteger()
          G.fromInt(A >> C)
          var L = new BigInteger('10' + F, 2)
          F = L.toRadix(10)
          var D = L.add(G)
          J = D.toRadix(10)
        } else {
          F = E.shiftLeft((~C)).intValue()
          J = (A >> C) + F
        }
      }
      return J
    },
    GetZ: function (L, B, F) {
      var M = CryptoJS.enc.Utf8.parse(F)
      var J = M.words.length * 4 * 8
      this.Update((J >> 8 & 255))
      this.Update((J & 255))
      var G = this.GetWords(M.toString())
      this.BlockUpdate(G, 0, G.length)
      var A = this.GetWords(L.curve.a.toBigInteger().toRadix(16))
      var C = this.GetWords(L.curve.b.toBigInteger().toRadix(16))
      var E = this.GetWords(L.getX().toBigInteger().toRadix(16))
      var D = this.GetWords(L.getY().toBigInteger().toRadix(16))
      var I = this.GetWords(B.substr(0, 64))
      var H = this.GetWords(B.substr(64, 64))
      this.BlockUpdate(A, 0, A.length)
      this.BlockUpdate(C, 0, C.length)
      this.BlockUpdate(E, 0, E.length)
      this.BlockUpdate(D, 0, D.length)
      this.BlockUpdate(I, 0, I.length)
      this.BlockUpdate(H, 0, H.length)
      var K = [this.GetDigestSize()]
      this.DoFinal(K, 0)
      return K
    },
    GetWords: function (C) {
      var A = []
      var D = C.length
      for (var B = 0; B < D; B += 2) {
        A[A.length] = parseInt(C.substr(B, 2), 16)
      }
      return A
    },
    GetHex: function (D) {
      var A = []
      var E = 0
      for (var B = 0; B < D.length * 2; B += 2) {
        A[B >>> 3] |= parseInt(D[E]) << (24 - (B % 8) * 4)
        E += 1
      }
      var C = new CryptoJS.lib.WordArray.init(A, D.length)
      return C
    }
  }

  Array.Clear = function (A, C, B) {
    for (const elm in A) {
      A[elm] = null
    }
  }

  Array.Copy = function (C, F, A, G, B) {
    var E = C.slice(F, F + B)
    for (var D = 0; D < E.length; D += 1) {
      A[G] = E[D]
      G += 1
    }
  }

  function roateLeft (A, B) {
    return (A << B) | (A >>> -B)
  }

  function hash (E) {
    if (E == undefined) {
      return undefined
    }
    if (E == '') {
      return undefined
    }
    var A = CryptoJS.enc.Utf8.parse(E)
    var C = new SM3Digest()
    A = C.GetWords(A.toString())
    C.BlockUpdate(A, 0, A.length)
    var D = new Array(32)
    C.DoFinal(D, 0)
    var B = C.GetHex(D).toString()
    return B
  }

  return {
    hash: hash
  }
})()

export function sm3Encode (param) {
  return SM3.hash(param)
}
